import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Button from "./Button";

class ConfirmationModal extends React.PureComponent {
  static propTypes = {
    bodyClassName: PropTypes.string,
    size: PropTypes.string,
    isVisible: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    children: PropTypes.any,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    btnConfirmText: PropTypes.string,
    btnConfirmColor: PropTypes.string,
    btnCancelText: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool
  };

  static defaultProps = {
    bodyClassName: "",
    size: "md",
    loading: false,
    btnConfirmText: "Confirmer",
    btnCancelText: "Annuler",
    disabled: false,
    children: null,
    text: null,
    btnConfirmColor: "success"
  };

  render() {
    const {
      bodyClassName,
      size,
      isVisible,
      title,
      text,
      children,
      loading,
      disabled,
      btnCancelText,
      btnConfirmText,
      onConfirm,
      onCancel,
      btnConfirmColor
    } = this.props;
    return (
      <Modal
        size={size}
        isOpen={isVisible}
        toggle={loading ? null : onCancel}
        centered
        fade={false}
      >
        <ModalHeader className="modal__header text-center">{title}</ModalHeader>
        <ModalBody className={`modal__body ${bodyClassName}`}>
          {text}
          {children}
        </ModalBody>
        <ModalFooter className="modal__footer">
          {onCancel && (
            <Button
              block
              size={size}
              color="warning"
              onClick={onCancel}
              text={btnCancelText}
            />
          )}
          <div />
          <Button
            block
            size={size}
            color={btnConfirmColor}
            onClick={onConfirm}
            loading={loading}
            text={btnConfirmText}
            disabled={disabled}
          />
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmationModal;
